/**
 * Collection Learning Formats Carousel
 * Uses shared initScrollSnapCarousel from utils.js
 */

(function () {
  "use strict";

  function init() {
    initScrollSnapCarousel({
      sectionSelector: ".collection-learning-formats",
      containerSelector: ".collection-learning-formats__cards-container",
      itemsContainerSelector: "#collection-learning-formats-cards-{sectionId}",
      itemSelector: ".collection-learning-formats__card",
      paginationSelector: "#collection-learning-formats-pagination-{sectionId}",
      dotClass: "collection-learning-formats__pagination-dot",
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
